var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9687 16.723C27.5707 12.8123 23.1166 9.60856 18.025 9.56731C12.9327 9.52525 9.12876 12.6603 9.52832 16.5725C9.92869 20.4816 14.3796 23.6853 19.4728 23.7274C24.566 23.7703 28.3691 20.6328 27.9687 16.723ZM11.1251 15.7435C10.7765 12.5915 14.0845 10.0607 18.5088 10.0963C22.9306 10.131 26.8009 12.7136 27.147 15.864C27.4932 19.0168 24.1892 21.5476 19.7633 21.5144C15.3415 21.4796 11.472 18.8979 11.1251 15.7435Z",
    fill: "#F8A883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9892 15.204C8.07505 18.2517 8.02733 22.9356 10.8825 25.671C13.7376 28.4056 18.4191 28.1517 21.3349 25.1065C24.2507 22.062 24.296 17.3765 21.4409 14.6395C18.5873 11.9048 13.9067 12.158 10.9892 15.204ZM20.2816 23.8091C17.7735 26.4257 13.7504 26.6449 11.2932 24.2944C8.83356 21.9399 8.87562 17.9071 11.3846 15.2874C13.8927 12.6668 17.9191 12.4524 20.3747 14.8021C22.8335 17.1549 22.7922 21.1861 20.2816 23.8091Z",
    fill: "#F37C4B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3925_19990",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 25,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 3.30908H25.0176V23.0602H1.25V3.30908Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3925_19990)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41177 7.07621C1.00155 11.3605 -0.376686 17.5715 3.33258 20.9443C7.0467 24.3163 14.4434 23.5794 19.8568 19.2943C25.2679 15.0091 26.6445 8.799 22.9328 5.42702C19.2203 2.05099 11.8236 2.79106 6.41177 7.07621ZM11.2565 5.39793C16.4718 3.4422 21.6305 5.42139 22.7758 9.81492C23.9227 14.2076 20.6251 19.3574 15.4099 21.3115C10.1929 23.2681 5.03669 21.2873 3.88735 16.8946C2.74044 12.4994 6.03963 7.35205 11.2565 5.39793Z",
    fill: "#F05A28"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/한화투자증권-30.a01f413824f266b5d423a44e1be1d801.svg";
export { ForwardRef as ReactComponent };